import React from 'react';
import { Clock, MapPin, Calendar } from 'lucide-react';

const QuickInfo = () => {
  return (
    <section className="bg-orange-700 text-white py-10 shadow-inner">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Updated Temple Timings */}
        <div className="flex items-center gap-4 justify-center text-center md:text-left">
          <Clock className="text-orange-300 shrink-0" size={32} />
          <div>
            <div className="flex flex-col">
              <p className="font-bold text-lg leading-tight">6:00 AM - 7:00 PM</p>
            </div>
            <p className="text-xs uppercase tracking-widest text-orange-200 mt-1">Devasthanam Timing</p>
          </div>
        </div>

        {/* Location Info */}
        <div className="flex items-center gap-4 justify-center border-y md:border-y-0 md:border-x border-orange-600/50 py-6 md:py-0">
          <MapPin className="text-orange-300 shrink-0" size={32} />
          <div>
            <p className="font-bold text-xl leading-tight text-center md:text-left">Shankarpalli Road</p>
            <p className="text-sm uppercase tracking-widest text-orange-200 text-center md:text-left">Chandippa, Telangana</p>
          </div>
        </div>

        {/* Festival Info */}
        <div className="flex items-center gap-4 justify-center text-center md:text-left">
          <Calendar className="text-orange-300 shrink-0" size={32} />
          <div>
            <p className="font-bold text-xl leading-tight">Maha Shivaratri</p>
            <p className="text-sm uppercase tracking-widest text-orange-200">Annual Grand Festival</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickInfo;